import API_URL from '../config';
import { getAuthHeaders } from '../utils/api';

/**
 * Search users by username
 * @param {string} query - Search query (minimum 2 characters)
 * @returns {Promise<Object>} Search results with users array
 */
// eslint-disable-next-line import/prefer-default-export
export const searchUsers = async (query) => {
  const response = await fetch(
    `${API_URL}/api/search/users?q=${encodeURIComponent(query)}`,
    { headers: getAuthHeaders() },
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Search failed');
  }

  return response.json();
};
